import React, {useEffect} from 'react';
import './information.scss';
import {HowItWorks} from './how_it_works';
import {Welcome} from './welcome';
import {Preparation} from './preparation';

import {triggerYaEvent} from '../../utils/yandex_counter';

function Information() {
    useEffect(function () {
        triggerYaEvent('Просмотр посадочной');
    }, []);

    return (
        <div className="information">
            <Welcome/>
            <Preparation/>
            <HowItWorks/>
        </div>
    );
}

export {Information};
